<template>
    <div>
        <modal-x :show="isAddingPost" @onclose="isAddingPost = false" :content-style="{ maxWidth: '800px' }">
            <add-post v-if="isAddingPost" @onadded="onPostAdded" :user-id="userId" :parent-id="parentId"></add-post>
        </modal-x>
        <modal-x :show="isEditingPost" @onclose="onPostClosed" :contentStyle="{ 'max-width': '800px' }">
            <post-editor v-if="isEditingPost" :user-id="userId" :edit-post-id="editingPostId"
                :parent-post-id="parentId"></post-editor>
        </modal-x>
        <query-menu v-if="showMenu" :filter-info="filterOptions" :show-query-menu="showMenu && filterOptions !== null"
            @onclose="showMenu = false" @onquery="onQuery"></query-menu>
        <div v-if="parentId === null">
            <div style="height:40px;">
                <span @click="isAddingPost = true" class="btn btn-default" style="color:red;font-weight: bolder;">
                    {{ lang.postList.add }}
                </span>
                <span class="btn btn-default" @click="showAll"> {{ lang.postList.showAll }}</span>
                <span @click="showFilterMenu" class="btn btn-default">
                    {{ lang.postList.postFilter }}
                </span>
                <div class="btn btn-default" style="float: right;" @click="$router.push({path:'ShopInfo',query:{ shopUserId: userId }})">
                    <span class="glyphicon glyphicon-home"></span>{{ lang.common.shopInfo }}
                </div>
            </div>
        </div>
        <paged-loading :is-loading="loadingImg" @pagechange="pageChange" :paging-info="paging">
            <div v-if="viewMode === 'post'">
                <template v-for="item in newItemsList">
                    <post :item="item" @onselect="onSelect"></post>
                </template>
                <template v-for="item in items">
                    <post :item="item" @onselect="onSelect"></post>
                </template>
            </div>

            <div v-if="viewMode === 'postRow'">
                <template v-for="item in newItemsList">
                    <post-row :item="item" @onselect="onSelect"></post-row>
                </template>
                <template v-for="item in items">
                    <post-row :item="item" @onselect="onSelect"></post-row>
                </template>
            </div>
        </paged-loading>
        <div style="clear: both;" v-if="parentId !== null">
            <div style="height:40px;">
                <span @click="isAddingPost = true" class="btn btn-default" style="color:red;font-weight: bolder;">
                    {{ lang.postList.addChild }}
                </span>
            </div>
        </div>
    </div>
</template>
<script>
import pagedLoading from '../components/base/PagedLoading.vue';
import queryString from '../utl/queryString';
import apis from '../api/extApi.js';
import addPost from './addPost.vue';
import modalX from '../components/base/ModalX1.vue';
import post from './sub/post.vue';
import postRow from './sub/postRow.vue';
import queryMenu from './queryMenu.vue';

export default {
    components: {
        pagedLoading: pagedLoading,
        addPost: addPost,
        modalX: modalX,
        post: post,
        postRow: postRow,
        queryMenu: queryMenu,
        postEditor: () => import('./postEditor.vue')
    },
    props: {
        "userId": String,
        "initFilter": {
            type: Object, default: null
        },
        "viewMode": {
            type: String, default: 'post'
        }
    },
    computed: {
        lang: function () {
            return this.$store.getters.lang;
        },
        parentId: function () {
            if (this.initFilter !== null && this.initFilter.prid !== null) {
                return this.initFilter.prid;
            }
            return null;
        },
        noRoute: function () {
            return this.initFilter !== null;
        }
    },
    data: function () {
        return {
            catCodes: apis.api.settings.catCodes,
            apiClient: apis.api,
            newItemsList: [],
            items: [],
            paging: { page: 1, pageSize: 1, count: 1 },
            loadingImg: false,
            categories: null,
            isAddingPost: false,
            isEditingPost: false,
            editingPostId: null,
            showMenu: false,
            filterScopes: null,
            currentQuery: null,
            filterOptions: null,
            loadedQuery: null
        };
    },
    methods: {
        showFilterMenu: function () {
            if (!this.filterInfo) {
                this.apiClient.getShopViewModelByUidPrms(this.userId).done((ret) => {
                    console.log('filterInfo', ret.value.filterInfo);
                    this.filterOptions = ret.value.filterInfo;
                    this.showMenu = true;
                });
            } else {
                this.filterOptions = this.filterInfo;
            }
        },
        showAll: function () {
            this.onQuery({ query: null });
        },
        onQuery: function (ret) {
            console.log("onQuery obj:", ret);
            var q = ret.query === null ? {} : ret.query;
            this.filterScopes = {
                cat: q.cat,
                tag: q.tag,
                keyword: (q.keyword && q.keyword !== null) ? q.keyword : ""
            };
            var obj = {
                page: 1,
                //uid: this.userId,
                ...this.filterScopes
            };
            if (this.parentId !== null) {
                obj.prid = this.parentId;
            }
            //var qs = queryString().getString(obj);
            //console.log("query string:", qs);
            //this.loadItems(qs);
            if (this.noRoute) {
                obj.uid = this.userId;
                var qs = queryString().getString(obj);
                this.loadItems(qs);
            } else {
                obj.shopUserId = this.userId;
                var newRoute = {
                    name: "PostList", query: obj
                };
                this.$router.push(newRoute);
            }
        },
        onPostAdded: function (dt) {
            this.isAddingPost = false;
            this.newItemsList.push(dt);
            //this.onSelect(dt);
            this.showPost(dt.postId);
        },
        onPostClosed: function () {
            console.log("currentQuery:", this.currentQuery);
            this.isEditingPost = false;
            this.loadItems(this.currentQuery);
        },
        // onPageChange: function (newPage) {
        //     var obj = { page: newPage, uid: this.userId, ...this.filterScopes };
        //     this.loadItems(queryString().getString(obj));
        // },
        getQueryFromRoute() {
            var route = this.$router.currentRoute;
            var query = route.query;
            var newQuery = {};
            for (var n in query) {
                newQuery[n] = query[n];
            };
            //newQuery.uid = newQuery.shopUserId;
            return newQuery;
        },
        pageChange: function (page) {
            // var route = this.$router.currentRoute;
            // var query = route.query;
            // var newQuery = {};
            // for (var n in query) {
            //     newQuery[n] = query[n];
            // };
            var newQuery = this.getQueryFromRoute();
            newQuery.page = page;
            if (this.noRoute) {
                newQuery.uid = this.userId;//add this only when loadItems as uid no need to present in url
                this.loadItems(queryString().getString(newQuery));
            } else {
                var newRoute = {
                    name: "PostList", query: newQuery
                };
                this.$router.push(newRoute);
            }
        },
        showPost: function (postId) {
            this.editingPostId = postId;
            this.isEditingPost = true;
        },
        onSelect: function (post) {
            if (post.parentId !== null) {
                this.showPost(post.postId);
            } else {
                this.$router.push({ name: "PostEditor", query: { shopUserId: post.userId, editPostId: post.postId } });
            }
        },
        loadItems: function (query) {
            this.currentQuery = query;
            this.loadingImg = true;
            this.newItemsList = [];
            this.apiClient.getShopItemsPrms(query).done((ret) => {
                this.loadingImg = false;
                var filter = ret.filter;
                this.paging = { page: filter.page, pageSize: filter.pageSize, count: filter.count };
                this.items = ret.items;
                this.loadedQuery = query;
            }).fail(() => {
                this.loadingImg = false;
            });
        },
        /*reload: function () {
            var obj = {
                uid: this.userId
            };
            if (this.parentId !== null) {
                obj.prid = this.parentId;
            }
            console.log('the filter info', this.filterInfo);
            if (!this.filterInfo) {
                this.apiClient.getShopViewModelByUidPrms(this.userId).done((ret) => {
                    //this.shopInfo = ret.value.shop;
                    console.log('filterInfo', ret.value.filterInfo);
                    this.filterOptions = ret.value.filterInfo;
                    this.loadItems(queryString().getString(obj));
                });
            } else {
                this.filterOptions = this.filterInfo;
                this.loadItems(queryString().getString(obj));
            }
        },
        */
        getRoutePage: function () {
            var rPage = this.$route.query.page;
            if (typeof rPage === "undefined") {
                rPage = 1;
            };
            return rPage;
        },
        getQueryString: function () {
            // var queryString = this.$route.fullPath;
            // queryString = queryString.split('?')[1];
            // if (queryString == null) {
            //     queryString = "";
            // }
            // return queryString;
            var q = this.getQueryFromRoute();
            q.uid = this.userId;
            return queryString().getString(q);
        },
        initPaging: function () {
            this.loadItems(this.getQueryString());
        }
    },
    watch: {
        '$route'(to, from) {
            console.log("route change To", to);
            console.log("route change From", from);
            if (this.noRoute) return;
            if (to.name === 'PostList') {
                console.log("handling route change", this.$route.query);
                this.page = this.getRoutePage();
                var qstr = this.getQueryString();
                console.log('loadedQuery:', this.loadedQuery, ',current query:', qstr, ',', this.loadedQuery === qstr);
                if (qstr === this.loadedQuery) {
                    return;
                }
                this.loadItems(qstr);
            }
        }
    },
    mounted: function () {

        if (this.parentId !== null) {
            var obj = {
                uid: this.userId,
                prid: this.parentId
            };
            this.loadItems(queryString().getString(obj));
            return;
        }
        this.initPaging();

    },
    // created: function () {
    //     this.reload();
    // },
    activated: function () {
        console.log("postlist activated!!!!!!");
        //this.reload();
        var q = this.getQueryString();
        this.loadItems(q);
    },
    deactivated: function () {
        console.log("postlist deactivated!!!!!");
    }
}
</script>